import { CalendarOutlined } from '@ant-design/icons';
import { DatePicker } from 'antd';
import React from 'react';
import withUser from '../../../../../../withUser';
import VariableContainer from './VariableContainer';

const DateVariable = ({ userCanEdit, label, value, onChange, onChangeIsDefaultValue, isDefaultValue }) => (
  <VariableContainer
    label={label}
    icon={<CalendarOutlined />}
    onChangeIsDefaultValue={onChangeIsDefaultValue}
    isDefaultValue={isDefaultValue}
    value={value}
    userCanEdit={userCanEdit}
  >
    <DatePicker
      className="w-full"
      format="DD/MM/YYYY"
      value={value}
      onChange={(_date, dateString) => onChange(dateString)}
      allowClear={userCanEdit}
      disabled={!userCanEdit}
    />
  </VariableContainer>
);

export default withUser(DateVariable);
